import { api } from './api';

const trackingEventTypes = {
  SAW_ACTION_PLAN: 0,
  REVEALED_THREE_ACTION_ITEMS: 1,
  REVEALED_MAX_ACTION_ITEMS: 2,
  CLICKED_LEARN_MORE: 3,
  CLICKED_SCHEDULE_CALL_LINK: 4,
  CLICKED_OTHER_EXTERNAL_LINK: 5,
  CONTINUED_FROM_THANK_YOU_PAGE: 6,
  CONTINUED_FROM_SCORE_INTRO_PAGE: 7,
  SUBMITTED_CONTACT: 9
};

const getEventType = type => trackingEventTypes[type];

export function trackEvent(type, payload = {}) {
  console.log(type, getEventType(type), 'LOOK HERE');
  return (dispatch, getState) => {
    return api.post('/api/tracking_events', { tracking_event_type: getEventType(type), payload }).then(response => {
      dispatch({ type: 'USER_BEHAVIOR_FETCHED', payload: response.data });
    });
  };
}
